import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Tooltip } from 'antd';
import { VipUserIcon } from '@/app/const/svg';
import { useTranslation } from 'react-i18next';

interface UserAvatarProps {
  userInfo: {
    avatar: string;
    name?: string;
    username?: string;
    userName?: string;
    userId?: number | string;
    isOfficial?: number;
    handle?: string;
  };
  showOfficial?: boolean;
  size?: number;
  className?: string;
  toAction?: boolean; // 跳转个人中心
  officialSize?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}
export default function UserAvatar({
  userInfo,
  size = 10,
  officialSize = 'size-2',
  className = '',
  showOfficial = false,
  toAction = true,
  onClick,
}: UserAvatarProps) {
  const { t } = useTranslation();
  const userName = userInfo?.name || userInfo?.username || userInfo?.userName || 'U';
  return (
    <div className="relative">
      <Avatar
        className={`relative w-${size} h-${size} rounded-full shadow-sm ${toAction ? 'cursor-pointer' : ''} ${className}`}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          if (toAction && userInfo?.handle) {
            e.stopPropagation();
            window.open(`/${userInfo.handle}`, '_blank');
          } else if (toAction && userInfo?.userId) {
            e.stopPropagation();
            window.open(`/profile/detail?id=${userInfo.userId}`, '_blank');
          } else {
            onClick?.(e);
          }
        }}
      >
        <AvatarImage src={userInfo?.avatar} />
        <AvatarFallback className="text-xs">{userName.charAt(0)}</AvatarFallback>
      </Avatar>
      {showOfficial && !!userInfo.isOfficial ? (
        <Tooltip title={t('liveDetail.officialVerified')}>
          <div className="absolute -right-0.5 -bottom-0.5 bg-primary rounded-full flex items-center justify-center border border-background-card cursor-pointer transition-all duration-300 p-0.5">
            <VipUserIcon className={`${officialSize} text-black`} />
          </div>
        </Tooltip>
      ) : null}
    </div>
  );
}
